/**
 * Shared IntersectionObserver controller. Direct port of src/hooks/useScrollAnimation.js,
 * applied declaratively via data attributes instead of a per-component React hook call —
 * replaces the dead Section.jsx wrapper's job too. See SHOPIFY_MIGRATION_PLAN.md §6/§10.
 * Usage: add `data-scroll-animate` (+ optional `data-threshold`, `data-root-margin`,
 * `data-once="false"`) to any element; it (and any `.fade-in-up` descendants) get `.visible`
 * toggled on intersect.
 */
(() => {
  const elements = document.querySelectorAll('[data-scroll-animate]');
  if (!elements.length) return;

  elements.forEach((el) => {
    const threshold = parseFloat(el.dataset.threshold) || 0.1;
    const rootMargin = el.dataset.rootMargin || '0px 0px -100px 0px';
    const triggerOnce = el.dataset.once !== 'false';

    const targets = el.classList.contains('fade-step') ? [el] : el.querySelectorAll('.fade-step');
    const toObserve = targets.length ? targets : [el];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            if (triggerOnce) observer.unobserve(entry.target);
          } else if (!triggerOnce) {
            entry.target.classList.remove('visible');
          }
        });
      },
      { threshold, rootMargin }
    );

    toObserve.forEach((target) => observer.observe(target));
  });
})();
